import { Controller } from 'stimulus'
import { throttle } from 'throttle-debounce'

export default class extends Controller {
  static values = {
    desktopContainerSelector: String,
    mobileContainerSelector: String,
    breakpoint: { type: Number, default: 1024 },
  }

  connect() {
    this.moveToAppropriateContainer()
  }

  moveToAppropriateContainer = throttle(100, () => {
    const isDesktop = window.innerWidth >= this.breakpointValue
    let container

    if (isDesktop) {
      container = this.getDesktopContainer()
      this.hideContainer(this.mobileContainerSelectorValue)
    } else {
      container = this.getMobileContainer()
      this.hideContainer(this.desktopContainerSelectorValue)
    }

    if (!container) {
      console.error('Target container not found')
      return
    }

    container.classList.remove('hidden')
    if (container !== this.element.parentElement) {
      container.append(this.element)
    }
  })

  getDesktopContainer() {
    return document.querySelector(this.desktopContainerSelectorValue)
  }

  getMobileContainer() {
    return document.querySelector(this.mobileContainerSelectorValue)
  }

  hideContainer(selector) {
    const container = document.querySelector(selector)
    if (container) {
      container.classList.add('hidden')
    }
  }
}
